// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"101":"5b39eccf","951":"aee18ef6","982":"d49d8283","997":"cf174ffd"}[chunkId] + ".chunk.js";
};